export const BLOCK_CAR_SELECT = 'BLOCK_CAR_SELECT';
export const BLOCK_TABS_SELECT = 'BLOCK_TABS_SELECT';
export const COLLAPSE_DATA_TEST_ATTRIBUTES = {
  'root': 'auto-params__root',
  'header-wrapper': 'auto-params',
};
